import React from 'react';
import { useTheme } from '@emotion/react';
import { type RestModalForwards } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { FunnelButton } from '@bbkFunnelComponents/v2';

type Props = {
  info: RestModalForwards;
  hide: React.MouseEventHandler;
  hideCancel: boolean;
  onClick: Function;
};

export const EmailSuccessActions: React.FC<Props> = ({
  info,
  hide,
  hideCancel,
  onClick,
}) => {
  const theme = useTheme() as EmotionTheme;

  const btnTextStyle = {
    fontSize: `calc(${theme.buttonFontSize} * 1.1)`,
    display: 'inline-block',
  };
  const btnSubTextStyle: React.CSSProperties = {
    display: 'inline-block',
    fontWeight: 'lighter',
    fontSize: `calc(${theme.buttonFontSize} * 0.9)`,
  };

  let labelText: React.ReactNode = info.text;
  if (info.subText) {
    labelText = (
      <span>
        <span style={btnTextStyle}>{info.text}</span>
        <span style={btnSubTextStyle}>{info.subText}</span>
      </span>
    );
  }

  const backwardsButtonStyles = {
    color: theme.primaryColor,
    fontSize: 18,
  };

  return (
    <div className="em-success-btns">
      <div className="em-fwd-btn">
        <div className="modal-email-actions">
          <div className="MEAContainer">
            <div className="es-btn">
              <FunnelButton
                onClick={() => onClick({ excludeOfferAccepts: true })}
                classes="d-flex align-items-center justify-content-center"
                specificStyles={{ textAlign: 'left' }}
              >
                {labelText}
              </FunnelButton>
            </div>
          </div>
        </div>
      </div>
      {!hideCancel && !info.hideCancelAction && (
        <div className="em-cnl-btn-w">
          <button
            className="em-cnl-btn"
            style={backwardsButtonStyles}
            onClick={hide}
          >
            {info.cancelText || 'Continue to cancel'}
          </button>
        </div>
      )}
    </div>
  );
};
